import { Content } from './styled'

const Component = props => {
    return (
        <Content>
            {props.children}
        </Content>
    )
}

export default Component